import { render, staticRenderFns } from "./FormActivity.vue?vue&type=template&id=04015b9e&"
import script from "./FormActivity.vue?vue&type=script&lang=js&"
export * from "./FormActivity.vue?vue&type=script&lang=js&"
import style0 from "./FormActivity.vue?vue&type=style&index=0&id=04015b9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormActivity.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports